/* istanbul ignore file */
// This file is ignored from coverage for now since in the near future we will move this mapping to Vulcan

import { IMelissaGetAddressResponseEntry } from '../MelissaApi';
import { FIELD_TYPE } from '../../constants/Constants';
import { IAddressResponse } from '../IApiResponses';
import addressMapper from './transaction/addressMapper';
import { IAddressAttributes } from '../../domain/entities/Address';

type IFromMelissaEntry = Partial<Record<FIELD_TYPE, unknown>>;

export type IFromMelissaGetAddressResponse = IAddressAttributes[];

enum MELISSA_FIELD_TYPE {
  COUNTRY = 'countryName',
  FIRST_LINE_ADDRESS = 'deliveryline1',
  SECOND_LINE_ADDRESS = 'deliveryline2',
  THIRD_LINE_ADDRESS = 'deliveryline3',
  ZIPCODE = 'postalCode',
  CITY = 'locality',
  STATE = 'administrativeArea',
  FULL = 'full',
} 

export const MELISSA_MAPPINGS: Partial<Record<FIELD_TYPE, MELISSA_FIELD_TYPE>> = {
  [FIELD_TYPE.FIRST_LINE_ADDRESS]: MELISSA_FIELD_TYPE.FIRST_LINE_ADDRESS,
  [FIELD_TYPE.SECOND_LINE_ADDRESS]: MELISSA_FIELD_TYPE.SECOND_LINE_ADDRESS,
  [FIELD_TYPE.FOURTH_LINE_ADDRESS]: MELISSA_FIELD_TYPE.THIRD_LINE_ADDRESS,
  [FIELD_TYPE.CITY]: MELISSA_FIELD_TYPE.CITY,
  [FIELD_TYPE.COUNTRY_LABEL]: MELISSA_FIELD_TYPE.COUNTRY,
  [FIELD_TYPE.ZIPCODE]: MELISSA_FIELD_TYPE.ZIPCODE,
  [FIELD_TYPE.STATE]: MELISSA_FIELD_TYPE.STATE,
  [FIELD_TYPE.FULL]: MELISSA_FIELD_TYPE.FULL,
};

const mapEntry = (entry: IMelissaGetAddressResponseEntry): IAddressResponse => {
  const mappedMelissaEntry: IFromMelissaEntry = {};
  const fieldTypes = Object.values(FIELD_TYPE);
  fieldTypes.forEach(fieldType => {
    const melissaField = MELISSA_MAPPINGS[fieldType as FIELD_TYPE];
    const value = entry[melissaField];
    if (value) {
      mappedMelissaEntry[fieldType as FIELD_TYPE] = value;
    }
  });
  return mappedMelissaEntry as IAddressResponse;
};

const melissaApiMapper = {
  response(data: IMelissaGetAddressResponseEntry[]): IFromMelissaGetAddressResponse {
    // TODO: Move mapping to Vulcan API
    return data?.map(entry => addressMapper.response(mapEntry(entry)));
  },
};

export default melissaApiMapper;